var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconParkSolidBroadcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.3167C12.6019 14.3175 13.1795 14.0792 13.6057 13.6543C14.0319 13.2293 14.272 12.6525 14.273 12.0507C14.2718 11.4489 14.0317 10.8722 13.6055 10.4474C13.1793 10.0226 12.6018 9.78436 12 9.78516C11.3984 9.78449 10.8212 10.0227 10.3951 10.4474C9.96895 10.8721 9.72886 11.4486 9.72754 12.0502C9.72847 12.652 9.96838 13.2289 10.3945 13.6539C10.8207 14.0789 11.3982 14.3173 12 14.3167Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 7.5C5.33349 9.985 5.33349 14.015 7.99999 16.5M16 16.5C18.6665 14.015 18.6665 9.985 16 7.5M4.92899 5C1.02399 8.893 1.02399 15.205 4.92899 19.098M19.071 19.098C22.976 15.205 22.976 8.893 19.071 5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkSolidBroadcast);
export default __webpack_public_path__ + "static/media/icon-park-solid_broadcast.87a2bae3641584b46a201f7020ad9985.svg";
export { ForwardRef as ReactComponent };